import fetch from 'cross-fetch';
import { getAnalyticsUrl } from './urls';
import { jsonAuth } from './Api';

const handleResponse = (responseFuture) =>
  responseFuture
    .then((response) => Promise.all([response.ok, response.json()]))
    .then(([responseOk, responseBody]) => {
      if (responseOk) {
        return responseBody;
      }
      // eslint-disable-next-line no-console
      console.error(`Analytics error: ${JSON.stringify(responseBody)}`);
      return {};
    });

const request =
  (url, jwt, method = 'GET') =>
  (args = {}) => {
    const { body, params = {} } = args;
    return handleResponse(
      fetch(`${getAnalyticsUrl()}${url}?${new URLSearchParams(params).toString()}`, {
        method,
        body: body ? JSON.stringify(body) : null,
        headers: jsonAuth(jwt),
      })
    );
  };

export const isHealthy = () => request('/', null)();

export const getExecutions = (jwt, page = 1) => request('/executions', jwt)({ params: { page } });

export const getResults = (jwt, execId) => request(`/results/${execId}`, jwt)();

export const getLogs = (jwt, execId) => request(`/logs/${execId}`, jwt)();

export const getSchedules = (jwt, page = 1) => request('/schedules', jwt)({ params: { page } });

export const modifySchedule = (jwt, schedule) =>
  request(`/schedules/${schedule.id}`, jwt, 'PUT')({ body: schedule });

export const getCodes = (jwt, page = 1) => request('/schedules', jwt)({ params: { page } });

export const checkSchedule = (jwt, schedule, thorough = true) =>
  request(`/run/${schedule.id}`, jwt, 'POST')({ body: null, params: { thorough } });

// TODO: crud endpoint handler here
